import * as _extractFiles2 from "extract-files";

var _extractFiles = "default" in _extractFiles2 ? _extractFiles2.default : _extractFiles2;

import * as _formData2 from "form-data";

var _formData = "default" in _formData2 ? _formData2.default : _formData2;

import { dew as _defaultJsonSerializerDew } from "./defaultJsonSerializer";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;

  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var extract_files_1 = _extractFiles;

  var form_data_1 = __importDefault(_formData);

  var defaultJsonSerializer_1 = _defaultJsonSerializerDew();
  /**
   * Duck type if NodeJS stream
   * https://github.com/sindresorhus/is-stream/blob/3750505b0727f6df54324784fe369365ef78841e/index.js#L3
   */


  var isExtractableFileEnhanced = function (value) {
    return extract_files_1.isExtractableFile(value) || value !== null && typeof value === "object" && typeof value.pipe === "function";
  };
  /**
   * Returns Multipart Form if body contains files
   * (https://github.com/jaydenseric/graphql-multipart-request-spec)
   * Otherwise returns JSON
   */


  function createRequestBody(query, variables, operationName, jsonSerializer) {
    if (jsonSerializer === void 0) {
      jsonSerializer = defaultJsonSerializer_1.defaultJsonSerializer;
    }

    var _a = extract_files_1.extractFiles({
      query: query,
      variables: variables,
      operationName: operationName
    }, "", isExtractableFileEnhanced),
        clone = _a.clone,
        files = _a.files;

    if (files.size === 0) {
      if (!Array.isArray(query)) {
        return jsonSerializer.stringify(clone);
      }

      if (typeof variables !== "undefined" && !Array.isArray(variables)) {
        throw new Error("Cannot create request body with given variable type, array expected");
      } // Batch support


      var payload = query.reduce(function (accu, currentQuery, index) {
        accu.push({
          query: currentQuery,
          variables: variables ? variables[index] : undefined
        });
        return accu;
      }, []);
      return jsonSerializer.stringify(payload);
    }

    var Form = typeof FormData === "undefined" ? form_data_1.default : FormData;
    var form = new Form();
    form.append("operations", jsonSerializer.stringify(clone));
    var map = {};
    var i = 0;
    files.forEach(function (paths) {
      map[++i] = paths;
    });
    form.append("map", jsonSerializer.stringify(map));
    i = 0;
    files.forEach(function (paths, file) {
      form.append("" + ++i, file);
    });
    return form;
  }

  exports.default = createRequestBody; //# sourceMappingURL=createRequestBody.js.map

  return exports;
}